(() => {
  const HOST_SELECTOR = [
    '[data-widerruf-popup-source]',
    '[data-widerruf-popup-active-host]'
  ].join(',');
  const OPEN_TRIGGER_SELECTOR = [
    '[data-widerruf-popup-open]',
    'a[href*="revoq=open"]',
    'a[href*="#revoq-widerruf"]'
  ].join(',');
  const STYLE_ATTRIBUTE = 'data-revoq-theme-overrides';

  function hideBranding(host) {
    if (!(host instanceof HTMLElement) || !host.shadowRoot) return;
    if (host.shadowRoot.querySelector(`[${STYLE_ATTRIBUTE}]`)) return;

    const style = document.createElement('style');
    style.setAttribute(STYLE_ATTRIBUTE, '');
    style.textContent = '.widerruf-form-branding { display: none !important; }';
    host.shadowRoot.appendChild(style);
  }

  function applyOverrides(root = document) {
    if (root instanceof HTMLElement && root.matches(HOST_SELECTOR)) {
      hideBranding(root);
    }

    root.querySelectorAll?.(HOST_SELECTOR).forEach(hideBranding);
  }

  function applyAfterOpen() {
    queueMicrotask(applyOverrides);
  }

  function isOpenTrigger(event) {
    return event.composedPath().some((element) => (
      element instanceof Element && element.matches(OPEN_TRIGGER_SELECTOR)
    ));
  }

  document.addEventListener('click', (event) => {
    if (isOpenTrigger(event)) applyAfterOpen();
  }, true);

  document.addEventListener('revoq:open', applyAfterOpen);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyAfterOpen, { once: true });
  } else {
    applyOverrides();
  }
})();
